import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Modal, Fade, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
const BookingModal = ({ isOpen, onClose, children }) => {
    const { t } = useTranslation();
    return (_jsx(Modal, { open: isOpen, onClose: onClose, children: _jsx(Fade, { in: isOpen, children: _jsxs(Box, { sx: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: '90%' },
                    maxHeight: '100svh',
                    overflowY: 'auto',
                    bgcolor: 'var(--primaryBgColor)',
                    border: '2px solid var(--actionColor)',
                    borderRadius: '8px',
                    boxShadow: 24,
                    p: 4,
                }, children: [_jsx(Typography, { variant: "h6", color: "var(--primaryFgColor)", gutterBottom: true, children: t('bookingModal.title') }), children] }) }) }));
};
export default BookingModal;
